import React from 'react';
import './AppAlert.css';

export type AppAlertType = 'alert' | 'confirm';

interface AppAlertProps {
  open: boolean;
  message: string;
  type: AppAlertType;
  onClose: (confirmed: boolean) => void;
}

/**
 * Platform-independent modal that replaces tg.showAlert / tg.showConfirm.
 * Used through the AlertContext / useAppAlert() hook - components should not
 * render this directly.
 */
export const AppAlert: React.FC<AppAlertProps> = ({ open, message, type, onClose }) => {
  if (!open) return null;

  // Backdrop click only dismisses an "alert" - "confirm" requires explicit choice.
  const handleBackdropClick = () => {
    if (type === 'alert') {
      onClose(false);
    }
  };

  return (
    <div
      className="app-alert-overlay"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      <div className="app-alert-modal" onClick={(e) => e.stopPropagation()}>
        <div className="app-alert-message">{message}</div>
        <div className="app-alert-actions">
          {type === 'confirm' && (
            <button
              type="button"
              className="app-alert-btn app-alert-btn-cancel"
              onClick={() => onClose(false)}
            >
              Отмена
            </button>
          )}
          <button
            type="button"
            className="app-alert-btn app-alert-btn-ok"
            onClick={() => onClose(true)}
            autoFocus
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};
